import { WebsiteAPI } from "./website/websiteapi";

export class NewsAPI {

    clientId: number;

    constructor(clientId: number) {
        this.clientId = clientId;
    }

    website(websiteId: number) {
        return new WebsiteAPI(websiteId, this.clientId)
    }
}